import React from 'react';
import { CircleCheckIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { mockupAlt, mockupImage, offerIncludes } from '../data/kit';
import { useCheckoutUrl } from '../hooks/useCheckoutUrl';
export function OfferSection() {
  const checkoutUrl = useCheckoutUrl();
  return <section className="section mist" id="offer-details" aria-labelledby="offer-title" data-id="element-143" data-mp="denbkq4h8d4u">
      <div className="wrap" data-id="element-144" data-mp="idi2yggifa0k">
        <div className="offer-wrap" data-id="element-145" data-mp="ic6ptq16cpws">
          <p className="eyebrow" data-id="element-146" data-mp="ifb1f8gyynxh">The complete Volume 1 kit</p>
          <h2 id="offer-title" data-id="element-147" data-mp="mdsb9zrrycil">
            Your next 13 weeks, organized.
            <br data-id="element-148" data-mp="rdenc5vv9mpt" />
            <span className="accent" data-id="element-149" data-mp="rey2ft5sdrq0">One simple payment.</span>
          </h2>
          <article className="offer-card" data-id="element-150" data-mp="wdj4ly4lmlh3">
            <header className="offer-header" data-id="element-151" data-mp="wchhgvab68j0">
              <h3 data-id="element-152" data-mp="2t5j8myiv1lrk">Kids Activity Club — Volume 1</h3>
              <p data-id="element-153" data-mp="2t6udz2ryf1ks">13 weekly sessions + 5 practical bonuses</p>
            </header>
            <div className="offer-body" data-id="element-154" data-mp="2y5fhpc6f03dz">
              <img className="product-mockup" src={mockupImage} alt={mockupAlt} loading="lazy" data-id="element-155" data-mp="2y67bqikd5t25" />
              <div className="offer-includes" data-id="element-156" data-mp="12pl8ajriwv52">
                <p className="eyebrow" data-id="element-157" data-mp="xwjwikmm5bpp">Everything included</p>
                <ul className="offer-list" data-id="element-158" data-mp="sxp02fvq3on4">
                  {offerIncludes.map(item => <li key={item} data-id="element-159" data-mp="svcockgk6aii">
                      <CircleCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-160" data-mp="owwsrs6evtth" />
                      <span data-id="element-161" data-mp="1lmmhyhw0vjfc">{item}</span>
                    </li>)}
                </ul>
              </div>
              <div className="price" data-id="element-162" data-mp="1gokz9y2idm4e">
                <strong className="price-amount" data-id="element-163" data-mp="1glgqene3m27e">$27</strong>
                <span className="price-currency" data-id="element-164" data-mp="1ckdci6fm2g8t">USD</span>
              </div>
              <p className="payment-type" data-id="element-165" data-mp="17nejjr7oofc7">One-time payment · Digital resources in English</p>
              <a className="cta" href={checkoutUrl} data-id="element-166" data-mp="16sywcj0z8fo">
                GET MY 13-WEEK ACTIVITY KIT
              </a>
              <p className="offer-guarantee" data-id="element-167" data-mp="3sbstu274apcq">
                <ShieldCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-168" data-mp="3sf6th2oeckgh" />
                10-day return request window — see policy below
              </p>
              <div className="micro-row" data-id="element-169" data-mp="2n6icgp6n782">
                <span data-id="element-170" data-mp="3ktl4v41iopi2">
                  <ShieldCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-171" data-mp="3ku2x7pl26jkp" />
                  Payment via Stripe
                </span>
                <span data-id="element-172" data-mp="3owzkvupgh5vi">
                  <DownloadIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-173" data-mp="3b3ruu7h0wifx" />
                  Email delivery after approval
                </span>
              </div>
              <p className="scope-note" data-id="element-174" data-mp="3fw1fp93a6sbc">
                <strong data-id="element-175" data-mp="3163mgeqhvcfa">This package covers weeks 1–13.</strong> Additional volumes in the planned annual series are
                not included.
              </p>
            </div>
          </article>
          <p className="currency-note" data-id="element-176" data-mp="2s4du96osg9gg">
            The checkout shows your final amount, currency and available payment methods before you pay.
          </p>
        </div>
      </div>
    </section>;
}